import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Snackbar, withStyles, IconButton } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import { closeError } from 'actions/view'

const mapStateToProps = (state) => ({
  err: state.view.error,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      closeError,
    },
    dispatch,
  )

class Snack extends Component {
  handleClose = () => {
    this.props.closeError()
  }

  render() {
    const message = this.props.err || ''

    return (
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={Boolean(this.props.err)}
        onClose={this.handleClose}
        ContentProps={{
          'aria-describedby': 'message-id',
          className: this.props.classes.snackbarError,
        }}
        message={
          <span id="message-id" style={{ color: '#fff' }}>
            {message}
          </span>
        }
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            style={{ padding: 5 }}
            onClick={this.handleClose}
          >
            <Close />
          </IconButton>,
        ]}
      />
    )
  }
}

const styles = theme => ({
  snackbarError: { backgroundColor: theme.palette.red },
})

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Snack))
